import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '产品详情'
          }
        }, {
          path: '/solution',
          name: 'solution',
          component: resolve => require(['@/view/jiejue'], resolve),
          meta: {
            title: '解决方案'
          }
        },
        // {
        //   path: '/tutorial',
        //   name: 'tutorial',
        //   component: resolve => require(['@/view/Software'], resolve),
        //   meta: {
        //     title: '视频教程'
        //   },
        //   children: [
        //     {
        //       path: '/tutorial',
        //       redirect: '/tutorial/web'
        //     },
        //     {
        //       path: '/tutorial/web',
        //       name: 'tutorial',
        //       component: resolve => require(['@/view/Software_web'], resolve),
        //       meta: {
        //         title: '视频教程丨溯源网页教程'
        //       }
        //     },
        //     {
        //       path: '/tutorial/weixin',
        //       name: 'tutorial',
        //       component: resolve => require(['@/view/Software_weixin'], resolve),
        //       meta: {
        //         title: '视频教程丨微信小程序教程'
        //       }
        //     }
        //   ]
        // }, 
        {
          path: '/download',
          name: 'download',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '申请试用'
          }
        }, 
        // {
        //   path: '/companyintroduction',
        //   name: 'companyintroduction',
        //   component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        //   meta: {
        //     title: '公司介绍'
        //   }
        // }, 
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js